<template>
  <swiper class="buttons pictures"
          :loop="true" :currentPage="currentPage"
          @slider-move="onSliderMove"
          @slide-touch-end="onSlideTouchEnd"
          @slide-change-page="onSlideChangePage">
    <div class="infinity-swipe-item" v-for="(picture, index) in pictures">
      <button :class="{active: currentPage==index+1}" @click="onButtonClick(index+1)">
        <svg viewBox="150 100 280 460" style="fill: white;" v-html="picture.image"></svg>
      </button>
    </div>
  </swiper>
</template>

<script>
  import {mapState} from 'vuex'
  import InfinitySwipe from '../../../../InfinitySwipe.vue'
  export default {
    name: 'pictures',
    components: {
      swiper: InfinitySwipe,
    },
    data(){
      return {
        touch_time: 0,
      }
    },
    props: ['pictures', 'selectedPicture'],
    computed: {
      ...mapState(['cart']),
      currentPage(){
        return this.pictures.indexOf(this.selectedPicture) + 1;
      }
    },
    created(){
      if (!this.selectedPicture){
        this.setPicture(this.pictures[0]);
      }
    },
    methods: {
      setPicture(picture){
        this.$emit('setPicture', picture);
      },
      setPage: function(page){
        if (this.pictures.length < page) return;
        this.setPicture(this.pictures[page-1])
      },
      onSlideTouchEnd: function(page, time){
        this.touch_time = time;
        this.onSlideChangePage(page);
      },
      onSlideChangePage: function(page){
        this.setPage(page);
      },
      onSliderMove: function(translate, delta){
        let item_width = 110;
        let page = this.currentPage;
        if (delta < 0){
          page = Math.floor(translate / item_width) * -1 + 1;
        } else {
          page = Math.floor(translate / item_width) * -1;
        }
        if (page <= 0) page = 1;
        if (page > this.pictures.length) page = this.pictures.length + 1;

        if (page != this.currentPage){
          this.onSlideChangePage(page);
        }
      },
      onButtonClick: function(page){
        if (this.touch_time < 300){
          this.onSlideChangePage(page);
        }
      },
    }
  }
</script>


<style scoped>

  .pictures{
    background-color: #ffffff;
    border-bottom: 1px solid gray;
    height: 50px;
    box-sizing: border-box;
  }

  .buttons > div {
    display: inline-block;
    position: relative;
    vertical-align: middle;
  }
  .buttons button {
    background-color: #333;
    color:#fff;
    border-color:black;
    width: 96px;
    margin: 4px 4px;
  }
  .pictures button {
    background-color: #333;
    color:#fff;
    border-color:black;
  }
  .infinity-swipe-item > button:not(.active) {
    background-color: gray;
    border: 0;
  }
</style>
